import { useCallback, useEffect, useState } from 'react';
import { ApiService, SrNotificationsFeed } from '../services/apiService';

const POLL_INTERVAL_MS = 60_000;

export function useSrNotifications(enabled: boolean) {
  const [feed, setFeed] = useState<SrNotificationsFeed | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    if (!enabled) return;
    setLoading(true);
    try {
      const data = await ApiService.getSrNotifications();
      setFeed(data);
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load notifications');
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      setFeed(null);
      return;
    }
    refresh();
    const interval = window.setInterval(refresh, POLL_INTERVAL_MS);
    const onRefresh = () => refresh();
    window.addEventListener('sr-notifications-refresh', onRefresh);
    return () => {
      window.clearInterval(interval);
      window.removeEventListener('sr-notifications-refresh', onRefresh);
    };
  }, [enabled, refresh]);

  return { feed, loading, error, refresh };
}
